<template>
    <div class="align-items-center">
        <div id="testimonials">
            <div class="testimonials-content h-100">
                <div class="h-100 position-relative">
                    <div class="current d-flex h-100" :style="{backgroundImage: 'url(' + require('../assets/images/testimonials-ellipse.svg')+')'}">
                    <transition name="zoom" mode="out-in">
                        <div v-if="current && current.img">
                            <img :src="require('../assets/images/testimonials/'+current.img)" class="testimonial-img">
                            <div class="name-title">
                                <div class="name">
                                    {{current.name}}
                                </div>
                                <div class="title">
                                    {{current.title}}
                                </div>
                            </div>
                            <div class="testimonial">
                                "{{current.text}}"
                                <div class="mt-2">
                                    <audio v-if="current.audio" controls>
                                        <source :src="require('../assets/audio/' + current.audio)" type="audio/mpeg">
                                    </audio>
                                </div>
                            </div>
                        </div>
                    </transition>
                    </div>

                </div>
                <div class="buttons" :style="{backgroundImage: 'url(' + require('../assets/images/testimonials-buttons-ellipse.svg')+')'}">
                    <button class="button next" @click="next">></button>
                    <button class="button previous" @click="previous"><</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    components: {
    },
    data() {
        return {
            testimonials: [
                {
                    name: 'Gamliel S.',
                    img: 'testimonio-gamliel.png',
                    title: 'Paramédico, Chile',
                    text: 'Descubrir el Talmud en español y gratis ha sido un regalo impagable, maravilloso y una bendición en mi vida',
                    audio: 'testimonio01.mp3',
                },
                {
                    name: 'Uriel Halack',
                    img: 'urielhalak.png',
                    title: 'Bajur yeshivá, Argentina',
                    text: 'Escuchando el Daf Hayomi a diario superé las pruebas de mi Yeshivá. ¡Mi nota más baja fue un 85%!',
                },
                {
                    name: 'Jaime Saba',
                    img: 'jaime_saba.png',
                    title: 'Emprendedor, México',
                    text: 'El Daf Hayomi cambió mi vida totalmente. Hoy me siento orgulloso porque Jabrutouch creó una disciplina en mí',
                },
                {
                    name: 'Moisés Guindi',
                    img: 'moisesguindi.png',
                    title: 'Abogado, México',
                    text: 'El Dafyomi me compromete a estudiar Torá. La tecnología nos cambió la vida, y esta App es para aprovecharla',
                },
                {
                    name: 'David Souss',
                    img: 'david_sous.png',
                    title: 'Empresario, Argentina',
                    text: 'Jabrutouch siempre está conmigo. Está conmigo en el avión, en el tren, en el coche',
                },
            ],
            current: {},
            index: 0,
        }
    },
    mounted() {
        this.selectTestimonial()
    },
    methods: {
        selectTestimonial () {
            this.current = false
            this.current = this.testimonials[this.index]
        },
        next () {
            if(this.index < this.testimonials.length - 1){
                this.index ++
            } else {
                this.index = 0
            }
            this.selectTestimonial()
            this.preloadNext()
        },
        preloadNext () {
            if (this.index === this.testimonials.length-1) return this.index = 0;

                let img = new Image();

            img.onload = () => {
                console.log('img preloaded');
            }

            img.src = require('../assets/images/testimonials/'+this.testimonials[this.index + 1].img)
        },
        previous () {
            if(this.index == 0){
                this.index = this.testimonials.length - 1
            } else {
                this.index --
            }
            this.selectTestimonial()
        }
    },
}
</script>
<style lang="scss">
#testimonials{
    margin: 140px auto;
    height: 540px;
    width: 100%;
    background-position: center;
    background-repeat: no-repeat;
    .current{
        background-repeat: no-repeat;
        background-size: 100%;
        position: relative;
        z-index: 0;
    }
    .position-relative{
        z-index: 10;
        width: 595px;
    }
}
.testimonials-content{
    width: 660px;
    display: block;
    margin: auto;
    color: #fff;
    position: relative;
    .testimonial-img{
        width: 186px;
        left: -100px;
        position: absolute;
        top: -30px;
        filter: drop-shadow(0px 12px 40px rgba(0, 0, 0, 0.25));
    }
    .name-title{
        margin-left: 116px;
        margin-top: 80px;
    }
    .name{
        font-weight: bold;
        font-size: 26px;
        line-height: 40px;
    }
    .profession{
        font-size: 22px;
        line-height: 34px;
    }
    .testimonial{
        font-weight: 300;
        font-size: 30px;
        line-height: 45px;
        padding: 30px 40px 50px 100px;
    }
}
.buttons{
    position: absolute;
    top: 30px;
    right: -70px;
    height: 100%;
    background-repeat: no-repeat;
    z-index: 0;
    width: 550px;
    .button {
        border: 0;
        border-radius: 100%;
        background: rgba(255, 255, 255, 0.5);
        color: #FF5F50;
        &.next{
            position: absolute;
            top: 200px;
            right: 30px;
            width: 86px;
            height: 86px;
            font-size: 60px;
            line-height: 30px;
            text-align: center;
        }
        &.previous{
            position: absolute;
            top: 300px;
            right:80px;
            width: 64px;
            height: 64px;
            font-size: 64px;
            line-height: 30px;
            text-align: center;
        }
    }
}
@media (max-width: 544px) {
    #testimonials{
        width: 100%;
        max-width: 350px;
        height: 330px;
        .position-relative{
            width: 100%;
        }
    }
    .testimonials-content{
        width: 100%;
        .testimonial-img{
            width: 80px;
            left: 0;
            top: -30px;
        }
        .name-title{
            margin-left: 50px;
            margin-top: 50px;
        }
        .name{
            font-weight: bold;
            font-size: 26px;
            line-height: 40px;
        }
        .profession{
            font-size: 22px;
            line-height: 34px;
        }
        .testimonial{
            font-weight: 300;
            font-size: 18px;
            line-height: 28px;
            padding: 16px 50px;
        }
    }
    .buttons{
        top: 80px;
        left: 0;
        height: 100%;
        width: 100%;
        background-size: contain;
        .button {
            z-index: 20;
            &.next{
                top: 235px;
                right: 30%;
                width: 40px;
                height: 40px;
                font-size: 40px;
            }
            &.previous{
                top: 235px;
                left: 30%;
                width: 40px;
                height: 40px;
                font-size: 40px;
            }
        }
    }
}
</style>